import React, {PropsWithChildren, useCallback, useMemo, useState} from "react";
import {Place} from "../types";
import {AutoComplete, AutoCompleteProps, Input, Select} from "antd";
import {lookupAddressInput} from "../maps-service";

export const AddressInput: React.FC<PropsWithChildren & {
    value?: Place | undefined
    onChange?: (place: Place | undefined) => void;
}> = (props) => {
    const [places, setPlaces] = useState<Place[]>([]);
    const [options, setOptions] = useState<AutoCompleteProps['options']>([]);

    const lookupAddresses = useCallback((text: string) => {
        lookupAddressInput(text).then(resp => {
            if (resp.places) {
                setPlaces(resp.places);
                var opts: NonNullable<AutoCompleteProps['options']> = [];
                resp.places.forEach(place => {
                    const newOption = {
                        key: place.id,
                        value: place.formattedAddress,
                        label: place.formattedAddress,
                    };
                    opts.push(newOption);
                });
                setOptions(opts);
            } else {
                setOptions([]);
                setPlaces([]);
            }
        })
        .catch((e) =>  {
            console.error(e);
            setOptions([]);
            setPlaces([]);
        });
    }, [setOptions]);

    const internalOnChange = useCallback((value: string | undefined) => {
        const selected = places.find((place) => place.formattedAddress === value);
        props.onChange && props.onChange(selected);
    }, [places, props.onChange]);

    return (
        <AutoComplete
            allowClear={true}
            options={options}
            onSelect={(selected: string | undefined) => internalOnChange(selected)}
            onSearch={lookupAddresses}
            onChange={(input: string | undefined) => {
                if (!input) {
                    setPlaces([]);
                    setOptions([]);
                }
            }}
        />
    )

}